export default __webpack_public_path__ + "sliderImage_3.png";